/**
 * @group DOM Attribute
 */
const name = 'list-offset';

export {name as LIST_OFFSET};

